import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';

const heightMappedProperties = {
  h: {
    property: 'height',
  },
  minH: {
    property: 'minHeight',
  },
  maxH: {
    property: 'maxHeight',
  },
};

export type WithHeightProps = Partial<
  Record<keyof typeof heightMappedProperties, StyledPropType>
>;

export const withHeight = createExtractCssFromProps(heightMappedProperties);
